/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable-next-line no-unused-vars */
import { Route, Routes } from "react-router-dom";
import PropTypes from "prop-types";

import LandingPage from "pages/LandingPage";
import ProjectPage from "pages/ProjectPage";
import NotFoundPage from "pages/NotFoundPage";
import Catalog from "pages/Catalog";
import About from "pages/About";
import { ProjectDetailPage } from "pages/ProjectDetailPage";
import { DiscussProjectPage } from "pages/DiscussProjectPage";
import AdminLogin from "pages/admin/AdminLogin";
import AdminDashboard from "pages/admin/AdminDashboard";
import AdminCatalog from "pages/admin/AdminCatalog";
import AdminSettings from "pages/admin/AdminSettings";
import { AdminAuthProvider } from "admin/AuthContext";
import ProtectedRoute from "admin/ProtectedRoute";

import "./assets/css/styles.css";

function AdminPage({ children }) {
  return (
    <AdminAuthProvider>
      <ProtectedRoute>{children}</ProtectedRoute>
    </AdminAuthProvider>
  );
}

AdminPage.propTypes = {
  children: PropTypes.node.isRequired,
};

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/product" element={<ProjectPage />} />
        <Route exact path="/project/:id" element={<ProjectDetailPage />} />
        <Route exact path="/contact-us" element={<DiscussProjectPage />} />
        <Route exact path="/catalog" element={<Catalog />} />
        <Route exact path="/about" element={<About />} />
        <Route
          path="/admin/login"
          element={(
            <AdminAuthProvider>
              <AdminLogin />
            </AdminAuthProvider>
          )}
        />
        <Route path="/admin" element={<AdminPage><AdminDashboard /></AdminPage>} />
        <Route path="/admin/catalog" element={<AdminPage><AdminCatalog /></AdminPage>} />
        <Route path="/admin/settings" element={<AdminPage><AdminSettings /></AdminPage>} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
